import { render, staticRenderFns } from "./MultifileUploader.vue?vue&type=template&id=457d7879&scoped=true&"
import script from "./MultifileUploader.vue?vue&type=script&lang=js&"
export * from "./MultifileUploader.vue?vue&type=script&lang=js&"
import style0 from "./MultifileUploader.vue?vue&type=style&index=0&id=457d7879&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d7879",
  null
  
)

export default component.exports